import CategoryIcon from '@mui/icons-material/Category';

export const MissionTypeIcon = () => <CategoryIcon />;
